var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { visible: _vm.$f.isAuthShown, "allow-close": "" },
      on: {
        "on-close": function($event) {
          return _vm.$f.$emit("login:close")
        }
      }
    },
    [
      _c(
        "form",
        {
          staticClass: "auth-modal",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c("p", {
            staticClass: "title",
            domProps: { textContent: _vm._s(_vm.title) }
          }),
          _c("p", {
            staticClass: "subtitle",
            domProps: { textContent: _vm._s(_vm.subtitle) }
          }),
          _vm.mode !== "register"
            ? [
                _c("ui-input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mode === "sms",
                      expression: "mode === 'sms'"
                    }
                  ],
                  attrs: {
                    type: "tel",
                    error: "",
                    label: "Телефон*",
                    placeholder: "+7 (***) ***-**-**",
                    mask: "phone",
                    validate: "phone",
                    clearable: ""
                  },
                  model: {
                    value: _vm.phone,
                    callback: function($$v) {
                      _vm.phone = $$v
                    },
                    expression: "phone"
                  }
                }),
                _c("ui-input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mode === "email",
                      expression: "mode === 'email'"
                    }
                  ],
                  ref: "email",
                  attrs: {
                    type: "text",
                    validate: "email",
                    label: "Email*",
                    error: _vm.emailError,
                    clearable: ""
                  },
                  on: { input: _vm.onInputEmail },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                }),
                _vm.needConfirmEmail
                  ? _c("p", { staticClass: "error status" }, [
                      _vm._v("\n        Email не подтверждён. "),
                      _c(
                        "span",
                        {
                          staticClass: "resend need-confirm-email",
                          on: { click: _vm.handleSendConfirmEmail }
                        },
                        [_vm._v("Отправить письмо повторно")]
                      )
                    ])
                  : _vm._e(),
                _c("ui-input", {
                  ref: "codeInput",
                  attrs: {
                    type: "tel",
                    name: "code",
                    mask: "code",
                    loading: _vm.codeSent && _vm.progress,
                    label: "Код*",
                    validate: "code",
                    placeholder: _vm.codeSent ? "Код подтверждения" : "••••••",
                    disabled: !_vm.codeSent,
                    error: _vm.codeError
                  },
                  on: {
                    input: function($event) {
                      _vm.codeError = ""
                    }
                  },
                  model: {
                    value: _vm.code,
                    callback: function($$v) {
                      _vm.code = $$v
                    },
                    expression: "code"
                  }
                }),
                _c("div", { staticClass: "status" }, [
                  _vm.retryTimeoutSeconds
                    ? _c("p", [
                        _vm._v(
                          "\n          Повторная отправка возможна через " +
                            _vm._s(_vm.retryTimeout) +
                            "\n        "
                        )
                      ])
                    : _vm.codeSent
                    ? _c(
                        "p",
                        {
                          staticClass: "resend",
                          on: { click: _vm.requestCode }
                        },
                        [_vm._v("\n          Отправить код повторно\n        ")]
                      )
                    : _vm._e()
                ]),
                _c("ui-button", {
                  attrs: {
                    text: _vm.actionButton.text,
                    disabled: _vm.actionButton.disabled,
                    loading: _vm.progress,
                    type: "submit",
                    wide: ""
                  }
                }),
                _c("ui-button", {
                  attrs: {
                    flat: "",
                    wide: "",
                    text:
                      "Войти по " +
                      (_vm.mode === "sms" ? "Email" : "номеру телефона")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toggleMode($event)
                    }
                  }
                })
              ]
            : [
                _c("ui-input", {
                  ref: "name",
                  attrs: {
                    error: "",
                    label: "Имя*",
                    placeholder: "Имя",
                    validate: "name"
                  },
                  model: {
                    value: _vm.name,
                    callback: function($$v) {
                      _vm.name = $$v
                    },
                    expression: "name"
                  }
                }),
                _c("ui-input", {
                  ref: "email",
                  attrs: {
                    type: "email",
                    label: "Email*",
                    placeholder: "Email",
                    validate: "email",
                    error: _vm.emailError
                  },
                  on: { input: _vm.onInputEmail },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                }),
                _c("ui-checkbox", {
                  attrs: {
                    label: "Получать сообщения об акциях, скидках и новостях"
                  },
                  model: {
                    value: _vm.subscription,
                    callback: function($$v) {
                      _vm.subscription = $$v
                    },
                    expression: "subscription"
                  }
                }),
                _c("ui-button", {
                  ref: "submit",
                  attrs: {
                    text: _vm.actionButton.text,
                    disabled: _vm.actionButton.disabled,
                    loading: _vm.progress,
                    type: "submit",
                    wide: ""
                  }
                })
              ],
          _c(
            "div",
            { staticClass: "agreement" },
            [
              _vm.mode === "register"
                ? [
                    _vm._v(
                      "\n        Нажимая на кнопку «Зарегистрироваться» вы принимаете условия\n        "
                    ),
                    _c(
                      "a",
                      { attrs: { target: "_blank", href: "/agreement" } },
                      [_vm._v("пользовательского соглашения")]
                    ),
                    _vm._v(" и\n        "),
                    _c(
                      "a",
                      { attrs: { target: "_blank", href: "/fun-club" } },
                      [_vm._v("правила клубной программы")]
                    ),
                    _vm._v(".\n      ")
                  ]
                : _vm._e(),
              _c("recaptcha-text")
            ],
            2
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }